export default __webpack_public_path__ + "static/trimble-globe-ccf44ec5728ed40d936c6fc1aa5ad90d.jpg";